import { render, staticRenderFns } from "./mobileTabView.vue?vue&type=template&id=0125bdc1&scoped=true"
import script from "./mobileTabView.vue?vue&type=script&lang=js"
export * from "./mobileTabView.vue?vue&type=script&lang=js"
import style0 from "./mobileTabView.vue?vue&type=style&index=0&id=0125bdc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125bdc1",
  null
  
)

export default component.exports